import imageCompression from 'browser-image-compression';

const compressImage = async (file, maxSizeMB = 1, maxWidthOrHeight = 1920) => {
  if (!file) return null;

  try {
    const options = {
      maxSizeMB,
      maxWidthOrHeight,
      useWebWorker: true,
      initialQuality: 0.8,
      fileType: file.type || 'image/jpeg',
    };

    const compressedBlob = await imageCompression(file, options);

    const originalName = file.name;
    const extension = originalName.substring(originalName.lastIndexOf('.') + 1);
    const baseName = originalName.substring(0, originalName.lastIndexOf('.')) || originalName;

    const compressedFileName = `${baseName}.${extension}`;

    const compressedFile = new File([compressedBlob], compressedFileName, {
      type: file.type || `image/${extension}`,
      lastModified: Date.now(),
    });

    if (compressedFile.size >= file.size) {
      return file;
    }

    return compressedFile;
  } catch (error) {
    console.error('Error compressing image', error);
    return file;
  }
};

export default compressImage;
